export class ListMongoDbBackupConfigsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "configs",
            "baseName": "configs",
            "type": "Array<MongoDbBackupConfig>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListMongoDbBackupConfigsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
